import angular from 'angular';

import VoiceDownPanelService from './voiceDownPanelService';
import VoiceDownComponent from './VoiceDownComponent';

export default angular
  .module('petroCloud.dashboard.voiceDownPanel', [])
  .service('VoiceDownPanelService', VoiceDownPanelService)
  .component(VoiceDownComponent.name, VoiceDownComponent)
  .name;
